import React from "react";
import ContentLoader from "react-content-loader";

const WebsitesPlaceholder = () => {
  return (
    <div className="row">
      <div className="col-lg-2 col-md-2 col-sm-6 col-xs-12 mt-3 opacity-100">
        <ContentLoader viewBox="0 0 500 400" className="mb-3 bra10">
          <rect x="0" y="0" rx="0" ry="0" width="100%" height="400" />
        </ContentLoader>
      </div>
      <div className="col-lg-2 col-md-2 col-sm-6 col-xs-12 mt-3 opacity-75">
        <ContentLoader viewBox="0 0 500 400" className="mb-3 bra10">
          <rect x="0" y="0" rx="0" ry="0" width="100%" height="400" />
        </ContentLoader>
      </div>
      <div className="col-lg-2 col-md-2 col-sm-6 col-xs-12 mt-3 opacity-50">
        <ContentLoader viewBox="0 0 500 400" className="mb-3 bra10">
          <rect x="0" y="0" rx="0" ry="0" width="100%" height="400" />
        </ContentLoader>
      </div>
      <div className="col-lg-2 col-md-2 col-sm-6 col-xs-12 mt-3 opacity-25">
        <ContentLoader viewBox="0 0 500 400" className="mb-3 bra10">
          <rect x="0" y="0" rx="0" ry="0" width="100%" height="400" />
        </ContentLoader>
      </div>
    </div>
  );
};

export default WebsitesPlaceholder;
